import VueRouter from 'vue-router'
import { Message } from "element-ui";
import store from "./store";
import userInfoHelper from "common/userInfo";
import { flattenMenuPaths, firstAccessibleMenuPath, hasPerm } from "common/permission";
import cookies from "js-cookie";
import Login from './Login'
import Home from './Home'
import Coin from './entries/Coin/route'
import MerchantCoin from './entries/MerchantCoin/route'
import Audit from './entries/Audit/route'
import UserOldRoute from './entries/UserOld/route'

import fundsRoutes from './entries/Funds/route'
import RebateListRoute from './entries/RebateList/route'
import RebateReviewRoute from './entries/RebateReview/route'
import PartnerListRoute from './entries/PartnerList/route'
import GiftCoinRoute from './entries/GiftCoin/route'
import FriendRoute from './entries/Friend/route'
import Contract from './entries/Contract/route'
import Simulation from './entries/Simulation/route'
import TransactionStatistics from './entries/TransactionStatistics/route'
import DataReportRoute from './entries/DataReport/route'
import PartnerDataStatistic from './entries/partnerDataStatistic/route'
import ActiveHistory from './entries/activeHistory/route'
import PlanHistory from './entries/planHistory/route'
import ProfitLossHistory from './entries/profitLossHistory/route'
// import OTCRoute from './entries/OTC/route'
import Tiger from './entries/Tiger/route'
import OrderLimit from './entries/OrderLimit/route'
import OrderLimitSpotAssets from './entries/OrderLimit/spotAssets/route'
import OrderLimitSpotTpsl from './entries/OrderLimit/spotTpsl/route'
import UserAddressRoute from './entries/Contract/UserAddress/route'
import UserLoginRoute from './entries/UserLoginLog/route'
import UserOrderLogRoute from './entries/UserOrderLog/route'
import UserVerifyRoute from './entries/UserVerifyCode/route'
import OperationLog from './entries/OperationLog/route'
import RebateRiskRoute from './entries/RebateRisk/route'
import ActivityRoute from './entries/Activity/route'
import ActivityTaskRecordRoute from './entries/ActivityTaskRecord/route'
import ActivityLotteryRoute from './entries/ActivityLottery/route'
import CopyuRoute from './entries/copy/route'
import SettingRoute from './entries/Setting/route'
import MessagePushChannelRoute from './entries/MessagePushTenant/MsgChannel/route'
import MessagePushBindRoute from './entries/MessagePushTenant/MsgBind/route'
import PublicAccountRoute from './entries/PublicAccount/route'
import PublicAccountTransferRoute from './entries/PublicAccount/Transfer/route'
import PublicAccountBillStatisticRoute from './entries/PublicAccount/BillStatistic/route'
import PublicAccountBalanceRoute from './entries/PublicAccount/Balance/route'
import WelfareRoute from './entries/Welfare/route'
import VipRoute from './entries/Vip/route'
import ProfitBonusActivityRoute from './entries/ProfitBonusActivity/route'
import UserRiskRoute from './entries/UserRisk/route'
import AbnormalAssetRoute from './entries/AbnormalAsset/route'

const HIDDEN_MENU_PREFIXES = [
  "/home/otc",
  "/home/otcBill",
  "/home/otctBill",
  "/home/audit/otc",
];

function shouldHideMenu(pathUrl = "") {
  return HIDDEN_MENU_PREFIXES.some(
    (prefix) => pathUrl === prefix || pathUrl.startsWith(`${prefix}/`)
  );
}

function filterMenuTree(nodes = []) {
  return (Array.isArray(nodes) ? nodes : [])
    .map((node) => ({
      ...node,
      children: filterMenuTree(node.children || []),
    }))
    .filter((node) => {
      if (shouldHideMenu(node.pathUrl || "")) {
        return false;
      }
      return !!(node.pathUrl || (node.children && node.children.length));
    });
}

function resolveParentMenuPath(path, allowedPaths = []) {
  // 以下 path 自身即为独立页面；若菜单里另有「/path/xxx」会被误判为「子 path」，
  // 守卫里若强行 next(子 path) 会导致无法进入本页（例如资金概览 vs 明细、订单限制 vs 现货资产）。
  const skipChildRedirect = new Set([
    "/home/funds",
    "/home/orderLimit",
  ]);
  if (skipChildRedirect.has(path)) {
    return path;
  }
  const childPaths = allowedPaths.filter(
    (item) => item !== path && item.startsWith(`${path}/`)
  );
  if (allowedPaths.includes(path) && childPaths.length) {
    return childPaths[0];
  }
  return path;
}

const routes = [
  { path: '/', component: Login },
  {
    path: '/home',
    component: Home,
    children: [
      SettingRoute,
      ActivityLotteryRoute,
      ActivityTaskRecordRoute,
      ActivityRoute,
      Coin,
      MerchantCoin,
      Audit,
      UserOldRoute,
      ...fundsRoutes,
      RebateListRoute,
      RebateReviewRoute,
      PartnerListRoute,
      GiftCoinRoute,
      FriendRoute,
      Contract,
      Simulation,
      TransactionStatistics,
      DataReportRoute,
      PartnerDataStatistic,
      ActiveHistory,
      PlanHistory,
      ProfitLossHistory,
      // OTCRoute,
      Tiger,
      OrderLimit,
      OrderLimitSpotAssets,
      OrderLimitSpotTpsl,
      UserAddressRoute,
      UserLoginRoute,
      UserOrderLogRoute,
      UserVerifyRoute,
      OperationLog,
      RebateRiskRoute,
      CopyuRoute,
      MessagePushChannelRoute,
      MessagePushBindRoute,
      PublicAccountRoute,
      PublicAccountTransferRoute,
      PublicAccountBillStatisticRoute,
      PublicAccountBalanceRoute,
      WelfareRoute,
      VipRoute,
      ProfitBonusActivityRoute,
      UserRiskRoute,
      AbnormalAssetRoute,
    ],
  },
]

const router = new VueRouter({ routes });

const routePermFallbackMap = {
  "/home/activity/typeManagement": "tenant:activity_task_mgmt:tab_type_management",
  "/home/activity/userTypeManagement": "tenant:activity_task_mgmt:tab_user_type_management",
  "/home/welfare/couponRecord": "tenant:coupon_mgmt:issue_record",
  "/home/welfare/management": "tenant:welfare_task_mgmt:tab_management",
  "/home/welfare/taskRecord": "tenant:welfare_task_mgmt:issue_record",
  "/home/activity/record/taskData": "tenant:activity_task_data:view",
  "/home/activity/record/userData": "tenant:activity_user_data:view",
  "/home/activity/record/statistics": "tenant:activity_statistics:view",
  "/home/simulation/fundRateRecord": "tenant:simulation_user:view",
  "/home/msgPush/channel": "tenant:msg_push_channel:view",
  "/home/msgPush/bind": "tenant:msg_push_bind:view",
  "/home/publicAccountTransfer": "tenant:public_account_transfer:view",
  "/home/publicAccountBillStatistic": "tenant:public_account_bill_statistic:view",
  "/home/publicAccountBalance": "tenant:public_account_balance:view",
  "/home/vip/level": "tenant:vip_level:view",
  "/home/vip/rate": "tenant:vip_rate:view",
  "/home/vip/approval": "tenant:vip_approval:view",
  "/home/vip/recharge-trial-card-approval": "tenant:vip_recharge_trial_card_approval:view",
  "/home/vip/migration-trial-card-approval": "tenant:vip_migration_trial_card_approval:view",
  "/home/vip/whitelist": "tenant:vip_whitelist:view",
  "/home/vip/user": "tenant:vip_user:view",
  "/home/profitBonus/activity": "tenant:profit_bonus_activity:view",
};

/** 明细子路由：按钮(271)/侧栏(270)的 perms 不在菜单 pathUrl 里时仍允许进入（与 api_mappings 菜单一致） */
const routePermFallbackAnyMap = {
  "/home/funds/rebate-detail": [
    "tenant:partner_funds_rebate_detail:view",
    "tenant:partner_funds:view_rebate_detail",
  ],
  "/home/funds/rebateDetail": [
    "tenant:partner_funds_rebate_detail:view",
    "tenant:partner_funds:view_rebate_detail",
  ],
  "/home/orderLimit/spotTpsl": [
    "tenant:spot_order_tpsl:view",
    "tenant:spot_order_limit:view",
  ],
};

router.beforeEach(async (to, from, next) => {
  if (to.path === "/") {
    next();
    return;
  }
  const token = cookies.get("admin-token");
  if (!token) {
    next("/");
    return;
  }

  let userInfo = store.state.userInfo || {};
  if (from.path === "/" || !userInfo.menuTree || !userInfo.menuTree.length) {
    const res = await store.dispatch("getUserInfo");
    if (!res || res.code !== 0) {
      userInfoHelper.clear();
      next("/");
      return;
    }
    userInfo = store.state.userInfo || {};
  }

  const menuTree = filterMenuTree(userInfo.menuTree || []);
  const allowedPaths = flattenMenuPaths(menuTree);
  const defaultPath = firstAccessibleMenuPath(menuTree);
  if (to.path === "/home") {
    next(defaultPath || "/");
    return;
  }
  if (allowedPaths.includes(to.path)) {
    const resolvedPath = resolveParentMenuPath(to.path, allowedPaths);
    if (resolvedPath !== to.path) {
      next(resolvedPath);
      return;
    }
    next();
    return;
  }
  const fallbackAnyPerms = routePermFallbackAnyMap[to.path];
  if (
    fallbackAnyPerms &&
    fallbackAnyPerms.some((p) => hasPerm(userInfo, p))
  ) {
    next();
    return;
  }
  const fallbackPerm = routePermFallbackMap[to.path];
  if (fallbackPerm && hasPerm(userInfo, fallbackPerm)) {
    next();
    return;
  }
  Message.error("无页面访问权限");
  next(defaultPath || "/");
});

export default router;
